var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalProfit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 259,
    viewBox: "0 0 284 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.372 67.6722L221.599 65.8223C222.456 66.1769 223.168 66.8078 223.624 67.6144C226.06 71.5167 225.451 80.4486 221.773 89.9007C218.128 99.3514 212.546 106.375 208.12 107.618C207.231 107.89 206.278 107.87 205.402 107.561L210.174 109.411C214.741 111.174 222.062 103.283 226.544 91.7492C231.026 80.2158 230.94 69.4324 226.372 67.6722Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.94 140.599L235.424 136.149C235.867 136.97 236.02 137.918 235.857 138.837C235.249 143.375 229.118 149.908 220.296 154.907C211.474 159.906 202.711 161.787 198.488 159.966C197.618 159.625 196.885 159.004 196.406 158.202L198.922 162.654C201.358 166.903 212.054 165.429 222.814 159.359C233.574 153.259 240.344 144.875 237.94 140.599Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.774 132.189C224.986 134.79 216.018 134.675 206.395 131.524C196.773 128.373 189.446 123.17 187.975 118.834C187.645 117.963 187.614 117.007 187.888 116.117L186.297 120.973C184.764 125.627 193.066 132.536 204.809 136.38C216.581 140.224 227.34 139.558 228.873 134.904L230.464 130.05C230.152 130.929 229.558 131.681 228.774 132.189Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.115 181.645C151.776 183.09 143.186 180.489 134.802 174.799C126.443 169.076 120.862 162.051 120.629 157.484C120.553 156.558 120.787 155.633 121.294 154.854L118.431 159.074C115.683 163.121 121.73 172.053 131.968 179.019C142.178 185.985 152.736 188.325 155.483 184.28L158.347 180.06C157.812 180.833 157.022 181.394 156.115 181.645Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.231 96.5126L144.459 94.6626C145.323 95.0216 146.037 95.6667 146.483 96.4882C148.919 100.391 148.31 109.322 144.656 118.775C140.983 128.227 135.43 135.222 131.004 136.494C130.115 136.766 129.162 136.746 128.285 136.436L133.058 138.284C137.625 140.049 144.975 132.127 149.429 120.596C153.917 109.064 153.801 98.2819 149.231 96.5126Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.16 148.576L167.816 143.824C168.008 144.671 167.921 145.558 167.569 146.352C165.895 150.629 158.371 155.514 148.595 158.231C138.818 160.969 129.852 160.688 126.207 157.913C125.441 157.385 124.879 156.609 124.616 155.716L126.005 160.63C127.335 165.346 138.066 166.469 149.983 163.145C161.9 159.821 170.491 153.288 169.16 148.576Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2304 177.251L92.2801 173.089C92.8038 173.853 93.0671 174.765 93.0321 175.69C92.9454 180.229 87.7039 187.195 79.6689 192.859C71.634 198.523 63.2991 201.127 58.9878 199.681C58.0978 199.412 57.3177 198.865 56.7621 198.12L59.7125 202.282C62.5456 206.271 72.7849 203.93 82.5903 197.023C92.3958 190.116 98.065 181.269 95.2304 177.251Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2515 176.269C74.8095 179.246 66.1321 180.026 56.5306 177.859C46.9291 175.691 39.4361 171.268 37.6139 167.106C37.2142 166.269 37.1024 165.324 37.2957 164.417L36.1677 169.389C35.102 174.188 43.6881 180.2 55.4025 182.859C67.1155 185.49 77.4995 183.755 78.5697 178.986L79.6977 174.014C79.4764 174.904 78.9682 175.696 78.2515 176.269Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0537 121.493L64.2233 119.82C65.0956 120.139 65.8431 120.725 66.3637 121.493C68.938 125.222 68.7355 133.952 65.496 143.229C62.2564 152.506 56.9921 159.474 52.655 160.804C51.7748 161.102 50.8223 161.112 49.936 160.833L54.7665 162.506C59.3944 164.125 66.3363 156.269 70.2944 144.931C74.2312 133.605 73.6817 123.112 69.0537 121.493Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0987 197.397C72.4378 204.016 62.5167 206.213 59.7414 202.282L56.7911 198.119C56.4576 197.619 56.227 197.057 56.1127 196.467C55.9985 195.877 56.003 195.27 56.1258 194.681C47.9052 196.011 42.1202 199.19 42.1202 202.918C42.1202 209.49 57.0606 211.792 64.4988 211.792C74.6224 211.792 83.1841 209.132 85.9639 205.463C88.4042 202.222 85.7721 199.251 82.0987 197.397Z",
    fill: "#4B9FFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159.008 178.147C158.968 178.829 158.749 179.486 158.371 180.055L155.508 184.275C152.76 188.322 142.231 185.981 131.992 179.015C130.231 177.812 128.541 176.509 126.93 175.112C120.972 176.731 117.067 179.419 117.067 182.483C117.067 189.04 132.138 191.357 139.455 191.357C146.869 191.357 161.842 189.052 161.842 182.483C161.747 181.588 161.44 180.728 160.947 179.974C160.455 179.221 159.79 178.594 159.008 178.147Z",
    fill: "#FFD155"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.048 156.006C226.374 157.206 224.636 158.316 222.843 159.33C212.054 165.429 201.378 166.903 198.951 162.625L196.435 158.173C196.028 157.431 195.868 156.579 195.978 155.739C191.003 157.676 187.503 161 190.222 164.613C196.489 172.981 226.749 173.069 233.145 164.613C235.86 160.993 232.239 157.805 228.048 156.006Z",
    fill: "#4B9FFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.006 248.82H279.476",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.842 248.82H189.204",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9033 248.82H117.038",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M264.898 240.958L279.476 248.82L264.898 256.71",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M277.089 71.1993V83.8311",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M283.408 77.5142H270.77",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0972 243.733C42.0972 250.302 57.071 252.607 64.4833 252.607C71.6018 252.607 86.871 250.325 86.871 243.733",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0972 238.616C42.0972 245.186 57.071 247.49 64.4833 247.49C71.6018 247.49 86.871 245.208 86.871 238.616",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0972 233.529C42.0972 240.098 57.071 242.403 64.4833 242.403C71.6018 242.403 86.871 240.121 86.871 233.529",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0972 228.414C42.0972 234.983 57.071 237.288 64.4833 237.288C71.6018 237.288 86.871 235.006 86.871 228.414",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0972 223.325C42.0972 229.894 57.071 232.199 64.4833 232.199C71.6018 232.199 86.871 229.917 86.871 223.325",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0972 218.209C42.0972 224.778 57.071 227.083 64.4833 227.083C71.6018 227.083 86.871 224.801 86.871 218.209",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0972 213.122C42.0972 219.691 57.071 221.996 64.4833 221.996C71.6018 221.996 86.871 219.714 86.871 213.122",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0972 208.005C42.0972 214.575 57.071 216.879 64.4833 216.879C71.6018 216.879 86.871 214.597 86.871 208.005",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.126 194.681C47.9053 196.011 42.1203 199.191 42.1203 202.918C42.1203 209.476 57.1916 211.792 64.4989 211.792C71.9127 211.792 86.8896 209.487 86.8896 202.918C86.8896 200.838 85.0932 198.902 82.0562 197.397",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0819 202.918V248.82C42.0819 253.705 52.1051 257.693 64.4833 257.693C76.8615 257.693 86.903 253.737 86.903 248.82V202.918",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M217.838 80.8774L213.239 79.5478C210.498 78.7749 208.446 85.7366 211.107 86.4851L213.651 87.2367C216.308 88.0521 214.208 94.9621 211.512 94.2015L206.945 92.8718",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.318 77.3215L209.419 96.4266",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M213.918 128.797L215.623 124.324C216.619 121.657 209.851 119.036 208.885 121.626L207.926 124.1C206.894 126.68 200.181 124.017 201.162 121.393L202.864 116.951",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M217.67 126.58L199.117 119.123",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M213.384 138.432C206.36 141.942 192.968 152.048 196.406 158.173C199.545 163.822 213.837 158.519 220.296 154.878C226.714 151.241 238.622 141.872 235.423 136.12C234.499 134.472 232.271 133.663 229.264 133.686",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M211.938 114.643C200.166 110.799 189.408 111.464 187.873 116.119C185.769 122.216 199.318 129.212 206.385 131.524C213.331 133.791 228.278 136.347 230.449 130.05C231.982 125.396 223.682 118.488 211.938 114.643Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M230.448 130.05L228.858 134.906C227.325 139.561 216.565 140.231 204.794 136.382C193.049 132.539 184.749 125.627 186.282 120.973L187.873 116.117",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M149.087 163.348C156.347 169.389 160.809 176.447 158.342 180.083C152.586 188.573 121.186 169.585 120.654 157.507C120.539 154.884 122.15 153.381 124.826 152.972",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.207 169.62L143.273 165.169",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M137.69 167.914L139.686 164.966",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M167.772 143.663C166.47 138.923 155.745 137.797 143.764 141.179C131.847 144.501 123.257 151.034 124.583 155.746C126.298 161.961 141.403 160.251 148.561 158.261C155.719 156.271 169.471 150.035 167.772 143.663Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M167.772 143.662L169.16 148.576C170.491 153.293 161.9 159.821 149.979 163.145C138.057 166.469 127.331 165.342 126 160.63L124.782 156.277",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M144.459 94.6691C139.891 92.9058 132.542 100.826 128.116 112.332C123.633 123.864 123.75 134.646 128.319 136.407C134.364 138.909 142.117 125.417 144.69 118.748C147.359 111.825 150.612 97.0028 144.459 94.6691Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.838 109.877L136.239 108.548C133.498 107.775 131.446 114.737 134.107 115.485L136.651 116.237C139.308 117.052 137.208 123.962 134.512 123.201L129.945 121.872",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M138.318 106.321L132.419 125.427",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M153.467 149.507L151.702 145.057C150.635 142.417 143.875 145.059 144.912 147.621L145.876 150.092C146.859 152.691 140.11 155.264 139.061 152.667L137.315 148.242",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M154.736 145.338L136.02 152.375",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M144.459 94.669L149.231 96.5129C153.798 98.2761 153.905 109.053 149.434 120.591C144.962 132.129 137.632 140.049 133.062 138.286L128.29 136.438",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M221.599 65.8225C217.032 64.0592 209.682 71.9794 205.257 83.4824C200.773 95.0158 200.889 105.798 205.459 107.561C211.503 110.06 219.258 96.5706 221.831 89.901C224.498 82.9727 227.753 68.1547 221.599 65.8225Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M221.599 65.8224L226.372 67.6723C230.939 69.4371 231.044 80.2113 226.572 91.7493C222.101 103.287 214.768 111.203 210.201 109.444L205.429 107.594",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7558 172.742C85.5986 170.545 90.4473 170.524 92.2802 173.089C96.0495 178.365 85.6534 188.645 79.6447 192.867C67.6181 201.296 54.9583 202.809 56.1305 194.659C56.5613 191.651 58.9636 187.779 62.7238 183.964",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7621 198.091C57.3177 198.836 58.0972 199.382 58.9877 199.652C62.6322 200.869 69.1342 199.209 75.9087 195.26C77.1509 194.534 78.3992 193.738 79.6399 192.86C87.6947 187.215 92.895 180.233 93.0031 175.69C93.0594 174.767 92.8049 173.851 92.28 173.089",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M92.28 173.089L95.2303 177.251C97.9827 181.154 92.7139 189.611 83.4245 196.42C77.1753 201.004 63.5487 207.727 59.7124 202.281L56.7621 198.089",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5371 187.918L69.4874 191.646C70.2105 192.571 72.0907 192.311 73.6815 191.097C75.2724 189.883 75.9955 188.149 75.2724 187.253L73.6237 185.171C73.434 184.855 73.3387 184.491 73.3489 184.122C73.3592 183.754 73.4746 183.396 73.6815 183.09",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0613 180.2C78.3133 180.181 78.5663 180.221 78.8003 180.316C79.0343 180.412 79.2431 180.56 79.4101 180.749L82.3604 184.507",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4168 180.142L66.4793 192.253",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7233 160.602C72.2932 163.29 80.8046 169.246 79.6979 174.014C78.2258 180.364 63.7513 179.517 56.5307 177.887C49.6665 176.337 35.8451 170.769 37.2959 164.446C37.9718 161.501 42.1552 159.706 47.9691 159.388",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6981 174.014L78.57 178.986C77.5044 183.755 67.1128 185.503 55.4029 182.859C43.693 180.215 35.0978 174.188 36.168 169.389L37.296 164.417",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5702 174.303L65.3801 169.587C65.8687 166.8 58.7076 165.57 58.2357 168.257L57.779 170.887C57.2903 173.614 50.1566 172.257 50.6361 169.529L51.446 164.846",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8388 171.412L48.1716 167.712",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M64.223 119.817C59.5951 118.198 52.6532 126.09 48.6631 137.421C44.7293 148.75 45.2789 159.243 49.9069 160.862C56.0724 162.992 63.1376 149.931 65.4668 143.258C67.8965 136.304 70.3779 121.938 64.223 119.817Z",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2231 119.817L69.0535 121.491C73.6814 123.109 74.2447 133.607 70.2972 144.932C66.3498 156.257 59.3927 164.125 54.7693 162.506L49.9389 160.833",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8377 134.877L58.2387 133.548C55.4984 132.775 53.4463 139.737 56.1074 140.485L58.6512 141.237C61.3077 142.052 59.2084 148.962 56.5123 148.201L51.9453 146.872",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3184 131.321L54.4193 150.427",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9712 78.2232L111.399 26.0498L145.905 59.9836L203.174 2.00023",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M173.208 2.00023H203.174V31.8294",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45795 189.16V132.911",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0.591873 147.478L8.45786 132.911L16.3543 147.478",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M158.123 180.378L155.479 184.275C152.739 188.322 142.178 185.973 131.963 179.014C121.748 172.056 115.674 163.116 118.426 159.069L121.319 154.878",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M196.406 158.174L198.922 162.625C201.358 166.874 212.06 165.411 222.814 159.33C233.568 153.249 240.341 144.848 237.94 140.571L235.424 136.149",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 202.889C189.261 209.458 204.235 211.763 211.649 211.763C218.766 211.763 234.028 209.481 234.028 202.889",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 197.775C189.261 204.342 204.235 206.647 211.649 206.647C218.766 206.647 234.028 204.365 234.028 197.775",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 208.064C189.261 214.633 204.235 216.938 211.649 216.938C218.766 216.938 234.028 214.656 234.028 208.064",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 213.209C189.261 219.778 204.235 222.083 211.649 222.083C218.766 222.083 234.028 219.801 234.028 213.209",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 218.354C189.261 224.923 204.235 227.228 211.649 227.228C218.766 227.228 234.028 224.946 234.028 218.354",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 223.499C189.261 230.068 204.235 232.373 211.649 232.373C218.766 232.373 234.028 230.091 234.028 223.499",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 228.644C189.261 235.214 204.235 237.518 211.649 237.518C218.766 237.518 234.028 235.236 234.028 228.644",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 233.79C189.261 240.359 204.235 242.664 211.649 242.664C218.766 242.664 234.028 240.382 234.028 233.79",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 238.935C189.261 245.504 204.235 247.809 211.649 247.809C218.766 247.809 234.028 245.527 234.028 238.935",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 244.085C189.261 250.654 204.235 252.959 211.649 252.959C218.766 252.959 234.028 250.677 234.028 244.085",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 192.687C189.261 199.257 204.235 201.56 211.649 201.56C218.766 201.56 234.028 199.278 234.028 192.687",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 187.571C189.261 194.141 204.235 196.445 211.649 196.445C218.766 196.445 234.028 194.163 234.028 187.571",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 182.484C189.261 189.053 204.235 191.358 211.649 191.358C218.766 191.358 234.028 189.076 234.028 182.484",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 177.368C189.261 183.937 204.235 186.242 211.649 186.242C218.766 186.242 234.028 183.96 234.028 177.368",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 172.277C189.261 178.846 204.235 181.151 211.649 181.151C218.766 181.151 234.028 178.869 234.028 172.277",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M189.261 167.164C189.261 173.733 204.235 176.038 211.649 176.038C218.766 176.038 234.028 173.756 234.028 167.164",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M189.248 162.633V248.833C189.248 253.718 199.269 257.707 211.649 257.707C224.029 257.707 234.049 253.751 234.049 248.833V162.724",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M228.013 156.005C232.275 157.808 235.886 160.965 233.132 164.619C226.754 173.087 196.479 172.987 190.21 164.619C187.512 161.035 190.938 157.734 195.85 155.795",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 223.326C117.033 229.895 132.007 232.2 139.421 232.2C146.538 232.2 161.809 229.918 161.809 223.326",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 218.21C117.033 224.779 132.007 227.084 139.421 227.084C146.538 227.084 161.809 224.802 161.809 218.21",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 228.5C117.033 235.069 132.007 237.374 139.421 237.374C146.538 237.374 161.809 235.092 161.809 228.5",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 233.645C117.033 240.214 132.007 242.519 139.421 242.519C146.538 242.519 161.809 240.237 161.809 233.645",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 238.79C117.033 245.359 132.007 247.664 139.421 247.664C146.538 247.664 161.809 245.382 161.809 238.79",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 243.933C117.033 250.502 132.007 252.807 139.421 252.807C146.538 252.807 161.809 250.525 161.809 243.933",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 213.122C117.033 219.692 132.007 221.996 139.421 221.996C146.538 221.996 161.809 219.714 161.809 213.122",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 208.006C117.033 214.575 132.007 216.88 139.421 216.88C146.538 216.88 161.809 214.598 161.809 208.006",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 202.918C117.033 209.487 132.007 211.792 139.421 211.792C146.538 211.792 161.809 209.51 161.809 202.918",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 197.804C117.033 204.371 132.007 206.676 139.421 206.676C146.538 206.676 161.809 204.394 161.809 197.804",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 192.716C117.033 199.285 132.007 201.589 139.421 201.589C146.538 201.589 161.809 199.307 161.809 192.716",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 187.6C117.033 194.169 132.007 196.474 139.421 196.474C146.538 196.474 161.809 194.192 161.809 187.6",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M117.033 182.789V249.081C117.033 255.648 132.006 257.953 139.412 257.953C146.529 257.953 161.79 255.671 161.79 249.081V182.902",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M159.001 178.164C161.565 179.962 162.807 182.5 160.917 185.027C158.14 188.698 149.578 191.357 139.451 191.357C129.325 191.357 120.737 188.698 117.986 185.027C114.534 180.425 120.97 176.739 126.886 175.123",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M223.479 146.409L221.128 142.239C219.713 139.768 213.372 143.299 214.747 145.697L216.037 148.015C217.361 150.458 211.023 153.919 209.632 151.488L207.303 147.34",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M224.172 142.106L206.579 151.61",
    stroke: "black",
    strokeWidth: 0.769171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProfit);
export default __webpack_public_path__ + "static/media/total_profit.65a3d48ea9ba430d70b2467b1989a1cb.svg";
export { ForwardRef as ReactComponent };